import React, { useEffect, useState } from "react";
import "./author.styles.scss";
import { Space, Divider, Tooltip, Row as AntRow, Col } from "antd";
import { ColumnType } from "antd/lib/table";
import CTable from "../../components/table/CTable";
import { QUERY_PARAM } from "../../constants/get-api.constant";
import { useSelectorRoot, useDispatchRoot } from "../../redux/store";
import Utils from "../../utils/base-utils";
import { 
    DeleteOutlined, 
    EditOutlined, 
    PlusOutlined,
    UserOutlined,
    FileTextOutlined,
    CloseOutlined
} from "@ant-design/icons";
import { Form, Input, Button, Modal } from "antd";
import { motion } from "framer-motion";
import { IAuthor } from "../../common/author.interface";
import { addAuthorRequest, deleteAuthorRequest, getListAuthorsRequest } from "../../redux/controller";
import CModalEditAuthor from "../../components/modal/CModalEditAuthor";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";


const Author = () => {
    const { authors, totalAuthorsRecords } =
        useSelectorRoot((state) => state.management);

    const [textSearch, setTextSearch] = useState("");
    const [openModalAdd, setOpenModalAdd] = useState(false);
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [author, setAuthor] = useState()
    const [currentSearchValue, setCurrentSearchValue] =
        useState<any>({
            size: QUERY_PARAM.size,
            offset: 0,
        });
    const dispatch = useDispatchRoot();
    const [newAuthor, setNewAuthor] = useState<any>()
    const [form] = Form.useForm();

    useEffect(() => {
        dispatch(getListAuthorsRequest(currentSearchValue));
    }, [dispatch, currentSearchValue]);

    useEffect(() => {
        console.log(authors);

    }, [authors]);



    const onChangePagination = (event: any) => {
        currentSearchValue.offset = (event - 1) * QUERY_PARAM.size;
        console.log(currentSearchValue);

        setCurrentSearchValue(currentSearchValue);
        dispatch(getListAuthorsRequest(currentSearchValue));
    };

    const onChangeInput = (event: any) => {
        setTextSearch(event.target.value);
    };

    const getAuthorName = (record: IAuthor) => {
        // Ưu tiên sử dụng trường name mới
        if (record.name) {
            return record.name;
        }
        
        // Fallback về format cũ để tương thích ngược
        let authorName = ""
        if (record.firstName) {
            authorName += record.firstName
        }
        if (record.middleName) {
            authorName += " " + record.middleName
        }
        if (record.lastName) {
            authorName += " " + record.lastName
        }
        return authorName || "Không có tên";
    }

    const columns: ColumnType<IAuthor>[] = [
        {
            title: "Số thứ tự",
            width: "120px",
            render: (_, __, rowIndex) =>
            (
                <div className="span-table" style={{ textAlign: "center" }}>
                    {currentSearchValue.offset + rowIndex + 1}
                </div>
            ),
        },
        {
            title: "Họ và tên",
            dataIndex: "name",
            key: "name",
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {getAuthorName(record)}
                </div>
            ),
        },
        {
            title: "Thời gian tạo",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {moment(record.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                </div>
            ),
        },
        {
            title: "Thao tác",
            key: "action",
            dataIndex: "action",
            render: (_, record) => (
                <Space size="middle" style={{ display: "flex", justifyContent: "center" }}>
                    <Tooltip placement="top" title={"Chỉnh Sửa"}>
                        <EditOutlined onClick={(event) => handleEdit(record)} />
                    </Tooltip>
                    <Tooltip placement="top" title={"Xóa"}>
                        <DeleteOutlined 
                            style={{ color: '#ff4d4f', cursor: 'pointer' }} 
                            onClick={(event) => handleDelete(record)} 
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const onSearch = () => {
        console.log("textSearch", textSearch);

        const body: any = {
            size: QUERY_PARAM.size,
            offset: 0,
            search: textSearch,
        };
        const finalBody = Utils.getRidOfUnusedProperties(body);
        setCurrentSearchValue(finalBody);
        dispatch(getListAuthorsRequest(finalBody));
    };

    const onCancelAddAuthor = () => {
        setOpenModalAdd(false);
        form.resetFields();
    };

    const handleAuthorChange = (event: { target: { value: any; name: string } }) => {
        setNewAuthor({ ...newAuthor, [event.target.name]: event.target.value });
    };

    const onAdd = (value: any) => {
        const bodyRequest = {
            name: value.name,
            description: value.description,
            birthYear: value.birthYear ? parseInt(value.birthYear) : undefined,
        }
        dispatch(addAuthorRequest(bodyRequest));
        setOpenModalAdd(false);
        form.resetFields();
    };

    const handleEdit = (record: any) => {
        setAuthor(record);
        setOpenModalEdit(true);
    };

    const handleDelete = (record: any) => {
        const bodyRequest = {
            id: record.id,
        }
        dispatch(deleteAuthorRequest(bodyRequest))
    };

    return (
        <motion.div
            className="sketch-main"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            {openModalAdd &&
                <Modal
                    open={openModalAdd}
                    onCancel={onCancelAddAuthor}
                    title={
                        <Space>
                            <PlusOutlined />
                            <span>Thêm tác giả</span>
                        </Space>
                    }
                    className="author-modal"
                    footer={null}
                    width={600}
                    destroyOnClose
                    maskClosable={true}
                >
                    <div className="modal-content">
                        <Form 
                            onFinish={onAdd}
                            form={form}
                            className="author-form"
                            layout="vertical"
                        >
                            <AntRow gutter={[16, 12]}>
                                <Col span={24}>
                                    <Form.Item
                                        label={
                                            <Space>
                                                <UserOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                                <span>Tên đầy đủ tác giả</span>
                                            </Space>
                                        }
                                        name="name"
                                        rules={[{ required: true, message: "Tên tác giả không được để trống!" }]}
                                    >
                                        <Input
                                            placeholder="Nhập tên đầy đủ tác giả (ví dụ: Nguyễn Nhật Ánh)"
                                            className="form-input"
                                            onChange={handleAuthorChange}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item
                                        label={
                                            <Space>
                                                <FileTextOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                                <span>Năm sinh</span>
                                            </Space>
                                        }
                                        name="birthYear"
                                        rules={[
                                            { 
                                                pattern: /^\d{4}$/, 
                                                message: "Năm sinh phải là 4 chữ số!" 
                                            },
                                            {
                                                validator: (_, value) => {
                                                    if (!value) return Promise.resolve();
                                                    const year = parseInt(value);
                                                    if (year < 1900 || year > new Date().getFullYear()) {
                                                        return Promise.reject(new Error('Năm sinh phải từ 1900 đến hiện tại!'));
                                                    }
                                                    return Promise.resolve();
                                                }
                                            }
                                        ]}
                                    >
                                        <Input
                                            placeholder="Nhập năm sinh (ví dụ: 1955)"
                                            className="form-input"
                                            onChange={handleAuthorChange}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <div style={{ height: '36px' }}></div>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label={
                                            <Space>
                                                <FileTextOutlined style={{ fontSize: '12px', color: 'var(--primary-color)' }} />
                                                <span>Mô tả về tác giả</span>
                                            </Space>
                                        }
                                        name="description"
                                    >
                                        <TextArea
                                            placeholder="Nhập mô tả"
                                            rows={4}
                                            className="form-textarea"
                                            onChange={handleAuthorChange}
                                            
                                        />
                                    </Form.Item>
                                </Col>
                            </AntRow>

                            <Divider style={{ margin: '16px 0' }} />

                            <div className="modal-actions">
                                <Button
                                    onClick={onCancelAddAuthor}
                                    className="cancel-button"
                                    icon={<CloseOutlined />}
                                >
                                    Hủy
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="save-button"
                                    icon={<PlusOutlined />}
                                >
                                    Thêm tác giả
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal>
            }
            {
                openModalEdit &&
                <CModalEditAuthor
                    open={openModalEdit}
                    data={author}
                    setOpenModalEdit={setOpenModalEdit}
                />
            }
            <div className="table-area">
                <CTable
                    tableMainTitle="Danh sách tác giả"
                    allowTextSearch={true}
                    onChangeInput={onChangeInput}
                    onSearch={onSearch}
                    titleOfColumnList={columns}
                    data={authors}
                    totalRecord={totalAuthorsRecords}
                    titleAddButton="Thêm tác giả"
                    textSearch="Nhập tên tác giả"
                    onChangePagination={onChangePagination}
                    allowAddObject={true}
                    pageSize={10}
                    size={450}
                    handleAddObject={() => setOpenModalAdd(true)}
                />
            </div>
        </motion.div >
    );
};

export default Author;
